import {Component, ChangeDetectionStrategy} from '@angular/core';
import {environment} from "../../../../environments/environment.development";
import {rNames} from '../../../r.names';
import { RouterLink } from '@angular/router';
import { CardBodyComponent } from '../../../../components/card/card-body/card-body.component';
import { CardComponent } from '../../../../components/card/card/card.component';
import { ContainerComponent } from '../../../../components/container/container.component';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ContainerComponent, CardComponent, CardBodyComponent, RouterLink]
})
export class FooterComponent {

  year = new Date().getFullYear();
  r = rNames;

  protected readonly environment = environment;
}
